module.exports = __webpack_public_path__ + "static/media/nr.f5da417c.svg";